import { createContext, useContext } from 'react';
import { Client } from '../../../shared';

export const ClientContext = createContext<Partial<Client>>({} as Client);

export const useClient = () => useContext(ClientContext);
